import { Component, input } from '@angular/core'

import { TranslatePipe } from '@ngx-translate/core'
import { DividerModule } from 'primeng/divider'

@Component({
  selector: 'app-product-note',
  imports: [DividerModule, TranslatePipe],
  templateUrl: './product-note.component.html',
  styleUrl: './product-note.component.scss'
})
export class ProductNoteComponent {
  showNoteForCustomers = input(false)
}
